import {
    GET_QUESTIONS_IN_PROJECT,
    QUESTION_TYPE_URLS,
    LIST_DATA_POINTS_URL,
    GET_ASSIGNED_DATA_POINTS,
} from "@/utils/constants/constants";
import axios from "axios";
import $ from "jquery";

export default {
    methods: {
        get_questions() {
            this.question_list = [];
            const payload = { project_id: this.project_id };

            axios
                .post(GET_QUESTIONS_IN_PROJECT, payload, { headers: this.headers })
                .then((response) => {
                    const response_data =
                        typeof response.data === "string"
                            ? JSON.parse(response.data)
                            : response.data;

                    const all_questions = response_data.data;
                    const dependent_question_ids = new Set();
                    all_questions.forEach((question) => {
                        if (question.dependent_questions && question.dependent_questions.length > 0) {
                            question.dependent_questions.forEach((dep) => {
                                dependent_question_ids.add(dep.id);
                            });
                        }
                    });

                    this.question_list = all_questions;

                    this.prep_tables();

                    this.$nextTick(() => {
                        const existing_table = $("#question_management_table").DataTable();
                        if (existing_table) {
                            existing_table.destroy();
                        }
                        $("#question_management_table").DataTable();
                    });
                })
                .catch((error) => {
                    if (error.response) {
                        this.show_error(error.response.data?.message || `Error: ${error.response.status}`);
                    }
                });

        },

        prep_tables() {
            if (this.question_list.length > 0) {
                const sorted_questions = [...this.question_list].sort(
                    (a, b) => a.id - b.id
                );

                this.table_safe_question_list = sorted_questions.map((question) => ({
                    id: question.id,
                    question: question.question_text,
                    type: this.format_question_type(question.question_type),
                    choices: (question.multi_select_choices || [])
                        .map((choice) => choice.choice)
                        .join(", "),
                    dependent_questions: question.dependent_questions || [],
                }));

                this.question_table_headers = ["question", "type", "choices"];
            }
        },

        get_data_points() {
            axios
                .get(LIST_DATA_POINTS_URL, {
                    params: { project_id: this.project_id },
                    headers: this.headers,
                })
                .then((response) => {
                    const response_data =
                        typeof response.data === "string"
                            ? JSON.parse(response.data)
                            : response.data;
                    this.data_points = response_data.data;
                })
                .catch((error) => {
                    this.show_error(`Error getting data points: ${error}`);
                });
        },

        async fetch_all_data_point_tags() {
            const response = await axios.get(GET_ASSIGNED_DATA_POINTS, {
                headers: this.headers,
                params: { project_id: this.project_id },
            });
            if (response.data.status === "success") {
                const tags_map = {};
                response.data.data.forEach((tag) => {
                    if (!tags_map[tag.data_point_id]) {
                        tags_map[tag.data_point_id] = [];
                    }
                    tags_map[tag.data_point_id].push({
                        id: Number(tag.tag_id),
                        tag_name: tag.tag_name,
                        data_point_id: tag.data_point_id,
                    });
                });
                this.data_point_tags = tags_map;
            }
        },

        get_tags_for_data_point(data_point_id) {
            const numeric_id = Number(data_point_id);
            if (!Number.isInteger(numeric_id)) {
                return [];
            }

            const data_point_exists = this.data_points.some(
                dp => dp.id === numeric_id
            );
            if (!data_point_exists) {
                return [];
            }

            if (!(this.data_point_tags instanceof Map)) {
                this.data_point_tags = new Map(Object.entries(this.data_point_tags));
            }

            if (this.data_point_tags.has(String(numeric_id))) {
                return this.data_point_tags.get(String(numeric_id)) || [];
            }

            return [];
        },

        load_tags_for_data_point(form) {
            if (!form.data_point_id) {
                form.available_tags = [];
                form.selected_tag = null;
                return;
            }

            form.available_tags = this.get_tags_for_data_point(form.data_point_id);
            form.selected_tag = null;
        },

        get_question_types() {
            axios
                .get(QUESTION_TYPE_URLS, { headers: this.headers })
                .then((response) => {
                    const response_data =
                        typeof response.data === "string"
                            ? JSON.parse(response.data)
                            : response.data;
                    this.question_types = response_data.data.map((type) => ({
                        ...type,
                        formatted_type: this.format_question_type(type.question_type),
                    }));
                })
                .catch((error) => {
                    this.show_error(`Error getting question types: ${error}`);
                });
        }
    }
};